import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EpicrisisEntity } from '../../../services/servicio-epicrisis.service';

@Component({
  selector: 'app-header-epicrisis',
  templateUrl: './header-epicrisis.component.html',
  styleUrls: ['./header-epicrisis.component.css']
})
export class HeaderEpicrisisComponent implements OnInit {

  imprimeServicios: boolean;
  imprimeCausal: boolean;

  @Input() public objectEpicrisis: EpicrisisEntity;
  @Output() filtrosSeleccionados: EventEmitter<any>;

  constructor() {
    this.filtrosSeleccionados = new EventEmitter();
  }

  ngOnInit() {
    this.imprimeServicios = true;
    this.imprimeCausal = false;
    this.onGenerar();
  }

  onGenerar() {
    this.objectEpicrisis.imprimeCausalAccidente = this.imprimeCausal;
    this.objectEpicrisis.imprimeServicios = this.imprimeServicios;
    this.filtrosSeleccionados.emit(this.objectEpicrisis);
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    const left = (screen.width / 2) - (screen.width / 4);
    printContents = document.getElementById('epicrisis-print').innerHTML;
    popupWin = window.open('', '_blank', `height=800px,width=1200px,left=${left}`);
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }

}
